import PropTypes from 'prop-types';
import React from 'react';
import { Switch, BrowserRouter as Router, Redirect, Route } from 'react-router-dom';
import { connect } from 'react-redux';

// Import Routes all
import { userRoutes, authRoutes, userPermissions } from './routes/allRoutes';

// Import all middleware
import Authmiddleware from './routes/middleware/Authmiddleware';

// layouts Format
import VerticalLayout from './components/VerticalLayout/';
import NonAuthLayout from './components/NonAuthLayout';

import DefaultPasswordChangeComponent from 'pages/UserManagement/DefaultChangePassword';

// Import scss
import './assets/scss/theme.scss';

// Import Firebase Configuration file
import { initFirebaseBackend } from './helpers/firebase_helper';

import ProtectedRoute from './routes/ProtectedRoute';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_APIKEY,
  authDomain: process.env.REACT_APP_AUTHDOMAIN,
  databaseURL: process.env.REACT_APP_DATABASEURL,
  projectId: process.env.REACT_APP_PROJECTID,
  storageBucket: process.env.REACT_APP_STORAGEBUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGINGSENDERID,
  appId: process.env.REACT_APP_APPID,
  measurementId: process.env.REACT_APP_MEASUREMENTID,
};

// Init Firebase backend
initFirebaseBackend(firebaseConfig);

const App = (props) => {
  
  const { isAuthenticated, needsPasswordChange } = props;
  
  function getLayout() {
    let layoutCls = VerticalLayout;
    return layoutCls;
  }

  const Layout = getLayout();

  return (
    <React.Fragment>
      <Router>
        <Switch>
          {authRoutes.map((route, idx) => (
            <Authmiddleware
              path={route.path}
              layout={NonAuthLayout}
              component={route.component}
              key={idx}
              isAuthProtected={false}
            />
          ))}

          {isAuthenticated && needsPasswordChange ? (
            // <Route path="/defaultPasswordChange" component={DefaultPasswordChangeComponent} />
            <ProtectedRoute 
              path="/defaultPasswordChange" 
              component={DefaultPasswordChangeComponent} 
              layout={null} 
              requiredPermissions={["defaultPasswordChange"]} 
              userPermissions={userPermissions} 
              needsPasswordChange = {needsPasswordChange}
            />
          ) : (
            userRoutes.map((route, index) => (
              <ProtectedRoute
                layout={Layout}
                key={index}
                exact
                isAuthProtected={true}
                path={route.path}
                component={route.component}
                requiredPermissions={route.requiredPermissions}
                userPermissions={userPermissions}
              />
            ))
          )}

          {/* Redirect to Dashboard if user is authenticated and no password change required */}
          {isAuthenticated && !needsPasswordChange && (
            <Redirect to="/dashboard" />
          )}

          {/* Fallback route */}
          <Route path="/" exact component={NonAuthLayout} />
        </Switch>
      </Router>
    </React.Fragment>
  );
};

App.propTypes = {
  layout: PropTypes.any,
  isAuthenticated: PropTypes.bool.isRequired,
  needsPasswordChange: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => {
  return {
    layout: state.Layout || {},
    isAuthenticated: (state.Auth && state.Auth.isAuthenticated) || false,
    needsPasswordChange: (state.Auth && state.Auth.needsPasswordChange) || false,
  };
};

export default connect(mapStateToProps, null)(App);
